/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, inject } from '@angular/core';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TravelDetailsService } from '../../../services/travel-details.service';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';

@Component({
  selector: 't-llevo-details-vehicle-section',
  standalone: true,
  imports: [
    PreloadImgComponent,
    DetailTabItemComponent
  ],
  template: `
    @if(data && data.vehicleType){
      <div class="row p-3 h-100">
        <t-llevo-detail-tab-item
          class="col-5 h-75"
          contentClasses="h-100 w-100 d-block text-dark"
          rowClasses="py-1"
          [data]="tabItems"
        ></t-llevo-detail-tab-item>
        <commonui-preload-img
          class="col-7 h-75"
          [urlImg]="data.vehicleType.photo"
          [containerClass]="'shadow-sm'"
          imgClass="w-100 h-100"
          [containerHeight]="100"
          [containerWidth]="100"
          unit="%"
        ></commonui-preload-img>
      </div>
    }
  `
})
export class DetailsVehicleSectionComponent{
  protected data: Travel | null = null
  private destroyRef = inject(DestroyRef);

  protected tabItems: TabElementContent[] = []

  constructor(private travelDetailsSrv: TravelDetailsService) {
    this.travelDetailsSrv.selectedTravel$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.data = data;
        this.assignData()
      });
  }

  private assignData(){
    if(this.data && this.data.driver){
      this.tabItems = [
        {
          name: 'Vehículo',
          value: this.data.vehicleType.name
        },
        {
          name: 'Matrícula',
          value: this.data.driver.vehicle.plate
        },
        {
          name: 'Marca',
          value: this.data.driver.vehicle.mark
        },
        {
          name: 'Modelo',
          value: this.data.driver.vehicle.model
        },
        {
          name: 'Color',
          value: this.data.driver.vehicle.color
        }
      ]
    }
  }
}
